/**
 * @flow
 * @relayHash 86408cf1f8d928d904edb11b1bb34b69
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EncodedRevenueValueTypeEnum = "AMAZON_CPM" | "%future added value";
export type LogUserRevenueAggregationOperationEnum = "MAX" | "%future added value";
export type LogUserRevenueInput = {|
  userId: string,
  revenue?: ?number,
  encodedRevenue?: ?EncodedRevenueValue,
  aggregationOperation?: ?LogUserRevenueAggregationOperationEnum,
  dfpAdvertiserId?: ?string,
  adUnitCode?: ?string,
  tabId?: ?string,
  adSize?: ?string,
  isV4?: ?boolean,
  clientMutationId?: ?string,
|};
export type EncodedRevenueValue = {|
  encodingType: EncodedRevenueValueTypeEnum,
  encodedValue: string,
  adSize?: ?string,
|};
export type LogUserRevenueMutationVariables = {|
  input: LogUserRevenueInput
|};
export type LogUserRevenueMutationResponse = {|
  +logUserRevenue: ?{|
    +success: boolean
  |}
|};
export type LogUserRevenueMutation = {|
  variables: LogUserRevenueMutationVariables,
  response: LogUserRevenueMutationResponse,
|};
*/


/*
mutation LogUserRevenueMutation(
  $input: LogUserRevenueInput!
) {
  logUserRevenue(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogUserRevenueInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "logUserRevenue",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LogUserRevenuePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LogUserRevenueMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "LogUserRevenueMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "LogUserRevenueMutation",
    "id": null,
    "text": "mutation LogUserRevenueMutation(\n  $input: LogUserRevenueInput!\n) {\n  logUserRevenue(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '15f5cc90b9b7975a47fe8855e9d34cda';
module.exports = node;
